function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: #fff;\n  border-radius: ",
        ";\n  min-height: 100%;\n  justify-content: flex-start;\n  padding: 15px;\n  width: 100%;\n\n  ",
        "\n\n  @media only screen and (min-width: 992px) {\n    &:hover {\n      box-shadow: 0px 5px 14px rgba(0, 0, 0, 0.25);\n    }\n    &:focus {\n      /* Visible in the full-colour space */\n      box-shadow: 0px 5px 14px rgba(0, 0, 0, 0.25);\n\n      /* Visible in Windows high-contrast themes */\n      outline-color: transparent;\n      outline-width: 2px;\n    }\n  }\n\n  @media screen and (min-width: ",
        "px) {\n    padding: 20px 25px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  color: #242526;\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0;\n  display: flex;\n\n  @media screen and (min-width: ",
        "px) {\n    font-size: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  border-radius: 3px;\n  object-fit: contain;\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  overflow: hidden;\n  margin-top: auto;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n  bottom: 0;\n  /*\n  This padding value sizes the image container to be 160px x 85px for the 214px x 187px tile...\n  and dynamically sizes the image container to maintain the same aspect ratio for different tile sizes.\n  For this to work with other tile sizes, the tile must keep the same width to height ratio (1.14:1)\n  */\n  padding: 38.3% 12.6% 9.4%;\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';
import Card from 'shared/components/card';
import Imgix from 'shared/components/imgix';
export default function CategoryTile(_param) {
    var label = _param.label, _param_breakpoint = _param.breakpoint, breakpoint = _param_breakpoint === void 0 ? "960" : _param_breakpoint, category = _param.category, imgSrc = _param.imgSrc, onClick = _param.onClick, children = _param.children, _param_disableImageAlt = _param.disableImageAlt, disableImageAlt = _param_disableImageAlt === void 0 ? false : _param_disableImageAlt, props = _object_without_properties(_param, [
        "label",
        "breakpoint",
        "category",
        "imgSrc",
        "onClick",
        "children",
        "disableImageAlt"
    ]);
    var computedLabel = label || (category === null || category === void 0 ? void 0 : category.label);
    return /*#__PURE__*/ _jsxs(StyledCard, _object_spread_props(_object_spread({
        breakpoint: breakpoint,
        alwaysShowShadow: true,
        onClick: onClick
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(CardHeader, {
                children: /*#__PURE__*/ _jsx(Title, {
                    breakpoint: breakpoint,
                    children: computedLabel
                })
            }),
            /*#__PURE__*/ _jsx(ImageContainer, {
                children: /*#__PURE__*/ _jsx(Image, {
                    src: imgSrc,
                    htmlAttributes: {
                        alt: disableImageAlt ? '' : computedLabel
                    }
                })
            })
        ]
    }));
}
export var StyledCard = styled(Card)(_templateObject(), function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_cards;
    return (_theme_customized_radius_cards = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.cards) !== null && _theme_customized_radius_cards !== void 0 ? _theme_customized_radius_cards : '17px';
}, layout, function(param) {
    var breakpoint = param.breakpoint;
    return breakpoint;
});
var Title = styled.span(_templateObject1(), function(param) {
    var breakpoint = param.breakpoint;
    return breakpoint;
});
var CardHeader = styled.div(_templateObject2());
var Image = styled(Imgix)(_templateObject3());
var ImageContainer = styled.div(_templateObject4());
